import React, { FC } from 'react';

import { FeatureSectionProps } from './FeatureSection';
import { FeaturesSectionLarge } from './FeaturesSectionLarge';
import { FeaturesSectionSmall } from './FeaturesSectionSmall';

export interface FeaturesSectionProps {
  heading: string;
  topSection?: FeatureSectionProps;
  sections: FeatureSectionProps[];
}

export const FeaturesSection: FC<FeaturesSectionProps> = (props) => (
  <>
    <FeaturesSectionLarge {...props} />
    <FeaturesSectionSmall {...props} />
  </>
);
